import { DEV__UserBanner } from './UserBanner/UserBanner'

export const DEV = {
  UserBanner: DEV__UserBanner
}
